// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*img{*/\n/*  margin: 0 auto;*/\n/*}*/\np[data-v-eaf2d902]{\n  text-align: center;\n  padding-bottom: 40px;\n}\nimg[data-v-eaf2d902] {\n  width: 146px;\n  height: 146px;\n}\n.tipTxt[data-v-eaf2d902] {\n  text-align: center;\n  display: block;\n  padding-bottom: 50px;\n}\n\n", ""]);
// Exports
module.exports = exports;
